export default {
  getShortcuts(state) {
    return state.shortcuts;
  },
};
